import { lazy } from './lazyLoading'

function getComponent(path, routes) {

    for (var i = 0; i < routes.length; i++) {
        if (routes[i].path == path) {
            console.log(routes[i].component);
            return routes[i].component;
        } else {
            if (routes[i].sysMenuVoChild && routes[i].sysMenuVoChild.length > 0) {
                getComponent(path, routes[i].sysMenuVoChild);
            }
        }
    }
}

/**
 * 拼接动态路由
 */
export default (routerList, routeHideList, sysMenuList) => {
    toRoutes(routerList, routeHideList, sysMenuList)
}

function toRoutes(routerList, routeHideList, sysMenuList) {
    if (sysMenuList) {
        for (var i = 0; i < sysMenuList.length; i++) {
            var sysMenuNode = sysMenuList[i];
            if (sysMenuNode.resoure_type == 'url') {
                var path = sysMenuNode.path;
                var routeNode = {};
                routeNode = {
                    name: sysMenuNode.path_name,
                    path: path,
                    component: lazy(path),
                    meta: { title: sysMenuNode.menuName, isMenuShow: sysMenuNode.isMenuShow },
                    children: []
                };

                //子节点存在
                if (sysMenuNode.sysMenuVoChild && sysMenuNode.sysMenuVoChild.length > 0) {
                    toRoutes(routeNode.children, routeHideList, sysMenuNode.sysMenuVoChild);
                }
                if (path && path != '') {
                    if (sysMenuNode.isShow == '1') {
                        if (sysMenuNode.isMenuShow == "1" || sysMenuNode.isShowInMainFrame == "1") {
                            routerList.push(routeNode);
                        }
                    } else {
                        routeHideList.push(routeNode);
                    }
                }
            } else {
                //子节点存在
                if (sysMenuNode.sysMenuVoChild && sysMenuNode.sysMenuVoChild.length > 0) {
                    toRoutes(routerList, routeHideList, sysMenuNode.sysMenuVoChild);
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/components/convertRoutes.js